// Site-wide configuration — edit these to update contact details everywhere.
export const WHATSAPP_NUMBER = "351918758292"; // +351 918 758 292
export const WHATSAPP_MESSAGE =
  "Olá AxioForm 3D! Gostaria de pedir informações sobre um orçamento de impressão 3D.";
export const CONTACT_EMAIL = "geral@axioform3d.com";

export const whatsappHref = () =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
